import {
  CREATE_WAITING_LIST,
  FETCH_WAITING_LIST,
  UPDATE_WAITING_LIST,
} from './constants';

const waitingList = (state = {}, action) => {
  switch (action.type) {
    case FETCH_WAITING_LIST:
    case UPDATE_WAITING_LIST:
    case CREATE_WAITING_LIST:
      return action.payload;
    default:
      return state;
  }
};

export default waitingList;

